import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.module.css'

const TextArea = ({ width, height, status, bgContainer, ...props }) => {
  const getInputType = (status) => {
    switch (status) {
      case 'error':
        return 'error'

      case 'warning':
        return 'warning'

      case 'ok':
        return 'ok'

      default:
        return ''
    }
  }

  return (
    <div
      style={{
        width,
        height,
        background: bgContainer
      }}
      className={`${styles.input_container}  ${getInputType(status)}`}
    >
      <textarea {...props} />
    </div>
  )
}

TextArea.propTypes = {
  placeholder: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  status: PropTypes.oneOf(['ok', 'error', 'warning']),
}

TextArea.defaultProps = {
  placeholder: '',
  width: '100%',
  height: 'auto',
}

export default TextArea
